'use strict';

import BaseService from './base.service';

class OperationProceduresService extends BaseService {
  /* @ngInject */
  constructor(OperationProcedure, SegaUser) {
    super(OperationProcedure, SegaUser);
    Object.assign(this, {
      OperationProcedure
    });
  }

  next(opts) {
    return this.Model.remoteNext(opts).$promise;
  }

  stay(opts) {
    return this.Model.remoteStay(opts).$promise;
  }

  postpone(opts) {
    return this.Model.remotePostpone(opts).$promise;
  }

  prev(opts) {
    return this.Model.remotePrev(opts).$promise;
  }

  deactivate(opts) {
    return this.Model.remoteDeactivate(opts).$promise;
  }

  reactivate(opts) {
    return this.Model.remoteReactivate(opts).$promise;
  }
}

export default OperationProceduresService;
